import React from "react";
import Checkbox from "@mui/material/Checkbox";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import makeStyles from "@mui/styles/makeStyles";
import FormControlLabel from "@mui/material/FormControlLabel";
var useStyles = makeStyles(function (_a) {
    var pxToRem = _a.typography.pxToRem;
    return ({
        toggle: {
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            marginTop: pxToRem(-8),
        },
        toggleLabel: {
            marginRight: 0,
            marginLeft: 0,
            "& .MuiFormControlLabel-label": {
                display: "none",
            },
        },
        toggleIcon: {
            fontSize: pxToRem(48),
        },
    });
});
var ToggleButton = function (_a) {
    var enabled = _a.enabled, onChange = _a.onChange;
    var classes = useStyles();
    return (React.createElement(FormControlLabel, { classes: { root: classes.toggleLabel }, label: "toggle", control: React.createElement(Checkbox, { className: classes.toggle, checked: enabled, onChange: onChange, checkedIcon: React.createElement(ToggleOnIcon, { color: "primary", className: classes.toggleIcon }), color: "primary", edge: "start", icon: React.createElement(ToggleOffIcon, { color: "action", className: classes.toggleIcon }) }) }));
};
export default ToggleButton;
//# sourceMappingURL=index.js.map